import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import columns from "../../columns/bookKeeping/columns";
import SkeletonTable from "../../components/table/SkeletonTable";
import {
  GetBookKeepingApi,
  GetBookKeepingQuestionListApi,
} from "../../api/request/documents/documents";
import moment from "moment";
import Eye from "../../assets/View";
import { Button } from "antd";
import { SubmitFileApi } from "../../api/request/service";
import UploadBookKeeping from "./components/UploadBookKeeping";

const BookKeeping = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [IsReUploadOpen, setIsReUploadOpen] = useState(false);
  const [questionList, setQuestionList] = useState([]);
  const [isQuestionLoading, setIsQuestionLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const getBookKeeping = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetBookKeepingApi();
      setData(
        data?.data?.map((item) => ({
          ...item,
          original_data: item,
          created_at: item?.submitted_date
            ? moment(item?.submitted_date).format("lll")
            : "--",
          FileName: (
            <p className="font-bold highlight-text capitalize">
              {item?.service_name_slug}
            </p>
          ),
          status: (
            <p
              className={`font-bold uppercase ${
                item?.status === "completed"
                  ? "text-green-500"
                  : item?.status === "inprocess"
                  ? "text-orange-500"
                  : "text-red-500"
              }`}
            >
              {item?.status}
            </p>
          ),
          action: (
            <div className="flex items-center gap-5">
              <button
                onClick={(e) => {
                  e?.stopPropagation();
                  handleFileView(item);
                }}
              >
                <Eye />
              </button>
              <Button
                className="btn-primary !px-2 !py-1 sm:gap-3 gap-1 !text-sm"
                disabled={!item?.is_enable_upload}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedFile(item);
                  setIsReUploadOpen(true);
                }}
              >
                Upload
              </Button>
            </div>
          ),
        }))
      );

      setIsLoading(false);
    } catch (error) {
      if (error?.response?.data?.message)
        toast?.error(error?.response?.data?.message);
      setIsLoading(false);
    }
  };

  const getReUploadFileList = async () => {
    if (!selectedFile) return;
    try {
      setIsQuestionLoading(true);
      const { data } = await GetBookKeepingQuestionListApi({
        file_id: selectedFile?.id,
      });
      setQuestionList(data?.data);
    } catch (error) {
      if (error?.response?.data?.message)
        toast?.error(error?.response?.data?.message);
    } finally {
      setIsQuestionLoading(false);
    }
  };

  useEffect(() => {
    getBookKeeping();
  }, []);

  useEffect(() => {
    getReUploadFileList();
  }, [selectedFile]);

  const handleFileView = (data) => {
    navigate(`/book_keeping/${data?.id}`, {
      state: { data: data?.original_data },
    });
  };

  const handleSubmit = async () => {
    try {
      setIsLoadingSubmit(true);
      let params = {
        file_id: selectedFile?.id,
      };

      const { data } = await SubmitFileApi(params);
      if (data?.status) {
        getBookKeeping();
        setIsReUploadOpen(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <>
      <div className="border rounded-xl bg-white">
        <div className="flex justify-between mx-5 mt-5">
          <p className="title">
            Book Keeping {data?.length ? `(${data?.length})` : ""}
          </p>
        </div>
        <div className="mt-5">
          <SkeletonTable
            columns={columns}
            data={data}
            isLoading={isLoading}
            onRowClick={(data) => handleFileView(data)}
          />
        </div>
      </div>

      <UploadBookKeeping
        isOpen={IsReUploadOpen}
        setIsOpen={setIsReUploadOpen}
        questionList={questionList}
        isQuestionLoading={isQuestionLoading}
        isLoadingSubmit={isLoadingSubmit}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default BookKeeping;
